
import { useState, useCallback } from 'react';
import { EnvironmentAnalysis, AudioQualityMetrics } from './types';

export const useEnvironmentAnalysis = () => {
  const [environmentAnalysis, setEnvironmentAnalysis] = useState<EnvironmentAnalysis | null>(null);

  const analyzeAudioEnvironment = useCallback((qualityMetrics: AudioQualityMetrics | null) => {
    if (!qualityMetrics) return;

    const { noiseLevel, signalLevel, speechRatio } = qualityMetrics;
    const signalToNoiseRatio = signalLevel - noiseLevel;

    let environment: EnvironmentAnalysis['environment'] = 'moderate';
    let confidence = 0.7;
    const recommendations: string[] = [];

    if (signalToNoiseRatio < 10 || noiseLevel > -50) {
      environment = 'noisy';
      confidence = 0.8;
      recommendations.push('Considere um ambiente mais silencioso.');
      recommendations.push('Use um microfone com cancelamento de ruído.');
    } else if (signalToNoiseRatio > 30 && noiseLevel < -70 && speechRatio > 0.6) {
      environment = 'quiet';
      confidence = 0.9;
      recommendations.push('Excelente ambiente de gravação!');
    }

    setEnvironmentAnalysis({
      environment,
      confidence,
      recommendations: recommendations.length > 0 ? recommendations : undefined
    });
  }, []);

  return {
    environmentAnalysis,
    analyzeAudioEnvironment
  };
};
